import React from 'react'
import * as S from './styles';
import { useLoginFormContext } from '@/main/hooks/loginHook';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import Button from '@/main/components/shared/button/button';
import { ArrowForward } from '@mui/icons-material';
import { getTranslateByKey } from '@/main/services/utils';
import { KeyValue } from '@/main/models/common';

interface ILoginUserLoggedQualitasProps {
  translatesLocal: KeyValue[]
}
function LoginUserLoggedQualitas({ translatesLocal }: ILoginUserLoggedQualitasProps) {

  const { updateHasUserLogged, submitInProgress, onSubmitLoginForm, methods } = useLoginFormContext()
  const formValues = methods.getValues()
  const { username } = formValues

  const messageLogged = getTranslateByKey('information.userhaveLogged', false, translatesLocal).replace('{0}', username)

  return (
    <S.Container>
      <p>{messageLogged}</p>
      <p>{getTranslateByKey('information.logoutInfo', false, translatesLocal)}</p>
      <p>{getTranslateByKey('information.doYouWhantContinue', false, translatesLocal)}</p>

      <S.ContainerButtons>
        <SecondaryButton
          type="button"
          onClick={() => updateHasUserLogged(false)}
          id="id-login-button-cancel"
          style={{
            borderColor: '#a31e8d',
            color: '#a31e8d',
          }}
        >
          {getTranslateByKey('information.cancel', false, translatesLocal)}
        </SecondaryButton>
        <Button
          type='button'
          isLoading={submitInProgress}
          onClick={() => onSubmitLoginForm({
            ...formValues,
            logoutAllDevices: true
          })}
          id="id-login-button-login"
          style={{
            backgroundColor: '#a31e8d',
          }}
        >
          {getTranslateByKey('information.login', false, translatesLocal)}
          {!submitInProgress && <ArrowForward fontSize="small" />}
        </Button>
      </S.ContainerButtons>

    </S.Container>
  )
}

export default LoginUserLoggedQualitas